/* cr-brand-pages-v1.js  -- data: Shopify Files cr-brand-pages-data.json  (Claude, Nov 1 2026)
   Runs only on brand pages: /pages/navigation?nav=<cat>&manufacturer=<maker> (no pattern).
   1) Adds a short write-up about the maker under the page heading.
   2) Turns the plain list of pattern names (ul.cr-patterns) into a picture grid.
      Picture order of preference: approved touched-up photo (BRAND_DATA images) ->
      Eli's own product photo of that pattern (dinner plate first) -> "No image available" tile.
*/
(function () {
  var qs = new URLSearchParams(location.search);
  var maker = qs.get('manufacturer'), nav = qs.get('nav');
  if (!maker || qs.get('pattern') || !/\/pages\/navigation/.test(location.pathname)) return;

  var DATA_URL = window.CR_BRAND_DATA_URL || ('/cdn/shop/files/cr-brand-pages-data.json?h=' + Math.floor(Date.now() / 600000)); // JSON {makers:{<maker>:{blurb:[..], images:{<pattern>:url}}}}
  var INLINE = window.CR_BRAND_DATA || null;

  var NOIMG = 'data:image/svg+xml,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">' +
    '<rect width="400" height="400" fill="#f4f6f9"/>' +
    '<circle cx="200" cy="180" r="112" fill="#fff" stroke="#d5dce6" stroke-width="3"/>' +
    '<circle cx="200" cy="180" r="78" fill="none" stroke="#e3e8ef" stroke-width="2"/>' +
    '<text x="200" y="338" text-anchor="middle" font-family="Jost,Helvetica,Arial,sans-serif" font-size="24" fill="#7a8799" letter-spacing="1">No image available</text>' +
    '</svg>');

  var css = '' +
    '.cr-brand-blurb{margin:0 0 2.8rem;padding:2rem 2.4rem;background:#f5f7fa;border:1px solid #e6e9ee;border-radius:4px}' +
    '.cr-brand-blurb h2{margin:0 0 .8rem;font-size:1.3rem;letter-spacing:.12em;text-transform:uppercase;font-weight:500;color:rgba(var(--color-foreground),.65)}' +
    '.cr-brand-blurb p{margin:0;font-size:1.55rem;line-height:1.7;color:rgba(var(--color-foreground),.88)}' +
    '.cr-brand-blurb p+p{margin-top:.8rem}' +
    '@media (max-width:600px){.cr-brand-blurb{padding:1.6rem}}' +
    'ul.cr-patterns.cr-pgrid{display:grid!important;grid-template-columns:repeat(auto-fill,minmax(170px,1fr));gap:18px;list-style:none;padding:0;columns:auto!important}' +
    '.cr-pgrid li{margin:0;break-inside:avoid}' +
    '.cr-pgrid a.cr-pcard{display:flex;flex-direction:column;gap:8px;text-decoration:none!important;color:rgb(var(--color-foreground));border:1px solid #e6e9ee;border-radius:4px;overflow:hidden;background:#fff;height:100%;transition:box-shadow .15s}' +
    '.cr-pgrid a.cr-pcard:hover,.cr-pgrid a.cr-pcard:focus-visible{box-shadow:0 4px 14px rgba(0,0,0,.10)}' +
    '.cr-pimg{position:relative;aspect-ratio:1/1;width:100%;background:#f4f6f9;display:flex;align-items:center;justify-content:center;overflow:hidden}' +
    '.cr-pimg::before{content:"";position:absolute;inset:-20px;background-image:var(--crbg,none);background-size:cover;background-position:center;filter:blur(16px);opacity:.85}' +
    '.cr-pimg img{position:relative;z-index:1;width:100%;height:100%;object-fit:contain;display:block}' +
    '.cr-pname{padding:0 12px;font-size:1.45rem;line-height:1.3}' +
    '.cr-pstock{padding:0 12px 12px;font-size:1.2rem;letter-spacing:.04em;text-transform:uppercase;color:#2f6b3a}' +
    '.cr-pstock.out{color:#8a8f98}' +
    '@media (max-width:600px){ul.cr-patterns.cr-pgrid{grid-template-columns:repeat(2,1fr);gap:12px}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); };
  var PIECE_RANK = [/dinner plate/i, /luncheon plate/i, /salad plate/i, /bread|b&b|butter plate/i, /cup (&|and) saucer/i, /plate/i, /saucer/i, /bowl/i, /platter/i, /cup/i];
  function rank(t) { for (var i = 0; i < PIECE_RANK.length; i++) if (PIECE_RANK[i].test(t)) return i; return PIECE_RANK.length; }

  function loadData() {
    if (INLINE) return Promise.resolve(INLINE);
    if (!DATA_URL) return Promise.resolve({ makers: {} });
    return fetch(DATA_URL).then(function (r) { return r.json(); }).catch(function () { return { makers: {} }; });
  }

  function loadPhotos() {
    var key = 'crBrandPhotos:' + nav + ':' + maker;
    try { var c = sessionStorage.getItem(key); if (c) return Promise.resolve(JSON.parse(c)); } catch (e) {}
    var q = 'vendor:"' + maker + '"';
    var url = function (p) { return '/search?type=product&view=cr-pattern&q=' + encodeURIComponent(q) + '&page=' + p; };
    return fetch(url(1)).then(function (r) { return r.json(); }).then(function (j) {
      var reqs = []; for (var p = 2; p <= Math.min(j.pages || 1, 4); p++) reqs.push(fetch(url(p)).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }));
      return Promise.all(reqs).then(function (rest) { return [j].concat(rest); });
    }).then(function (pages) {
      var best = {};
      pages.forEach(function (pg) { (pg.products || []).forEach(function (p) {
        var n = p.native || {}; if (!p.featured_image || !n.pattern) return;
        if (norm(n.manufacturer) !== norm(maker)) return;
        if (nav && n.category && norm(n.category) !== norm(nav)) return;
        if (/imperfect/i.test(p.title)) return;
        var k = norm(n.pattern), r = rank(p.title) - (p.in_stock ? 0.5 : 0);
        if (!best[k] || r < best[k].r) best[k] = { r: r, img: p.featured_image.replace(/width=\d+/, 'width=400') };
      }); });
      var out = {}; Object.keys(best).forEach(function (k) { out[k] = best[k].img; });
      try { sessionStorage.setItem(key, JSON.stringify(out)); } catch (e) {}
      return out;
    }).catch(function () { return {}; });
  }

  function addBlurb(info) {
    if (!info || !info.blurb || document.querySelector('.cr-brand-blurb')) return;
    if (info.draft && !/crbrand=1/.test(location.search)) return; // write-up waiting for Eli's OK
    var h1 = document.querySelector('h1.title') || document.querySelector('h1'); if (!h1) return;
    var box = document.createElement('section'); box.className = 'cr-brand-blurb';
    var h = document.createElement('h2'); h.textContent = 'About ' + maker; box.appendChild(h);
    [].concat(info.blurb).forEach(function (t) { var p = document.createElement('p'); p.textContent = t; box.appendChild(p); });
    h1.insertAdjacentElement('afterend', box);
  }

  function buildGrid(ul, info, photos) {
    if (ul.classList.contains('cr-pgrid')) return;
    var approved = (info && info.images) || {};
    if (info && info.imagesPending && /crphotos=1/.test(location.search)) approved = Object.assign({}, approved, info.imagesPending); // photos waiting for Eli's OK
    var approvedN = {}; Object.keys(approved).forEach(function (k) { approvedN[norm(k)] = approved[k]; });
    ul.classList.add('cr-pgrid');
    var missing = [];
    [].forEach.call(ul.querySelectorAll(':scope > li'), function (li) {
      var a = li.querySelector('a'); if (!a || a.classList.contains('cr-pcard')) return;
      var name = a.textContent.trim(), k = norm(name);
      if (info && info.hidePatterns && info.hidePatterns.map(norm).indexOf(k) >= 0) { li.remove(); return; } // merged into another pattern
      var src = approvedN[k] || photos[k] || NOIMG;
      a.classList.add('cr-pcard'); a.textContent = '';
      var box = document.createElement('span'); box.className = 'cr-pimg';
      var img = document.createElement('img'); img.loading = 'lazy'; img.decoding = 'async';
      img.alt = src === NOIMG ? '' : maker + ' ' + name + ' pattern'; img.src = src;
      if (src !== NOIMG) box.style.setProperty('--crbg', 'url("' + src + '")');
      img.onerror = function () { img.onerror = null; img.src = NOIMG; img.alt = ''; box.style.removeProperty('--crbg'); };
      box.appendChild(img);
      var nm = document.createElement('span'); nm.className = 'cr-pname'; nm.textContent = name;
      a.appendChild(box); a.appendChild(nm);
      if (src === NOIMG && missing.length < 6) missing.push({ k: k, name: name, img: img });
      if (li.dataset.stock) { var s = document.createElement('span'); var inS = li.dataset.stock === 'true'; s.className = 'cr-pstock' + (inS ? '' : ' out'); s.textContent = inS ? 'In stock' : 'Sold out'; a.appendChild(s); }
    });
    // Second try for patterns the maker-wide search missed (search stops at 1,000 results).
    (function next(i) {
      if (i >= missing.length) return;
      var m = missing[i], q = 'vendor:"' + maker + '" "' + m.name + '"';
      fetch('/search?type=product&view=cr-pattern&q=' + encodeURIComponent(q) + '&page=1').then(function (r) { return r.json(); }).then(function (j) {
        var bestR = 99, bestImg = null;
        (j.products || []).forEach(function (p) { var n = p.native || {}; if (!p.featured_image || norm(n.pattern) !== m.k || norm(n.manufacturer) !== norm(maker) || /imperfect/i.test(p.title)) return; var r = rank(p.title) - (p.in_stock ? 0.5 : 0); if (r < bestR) { bestR = r; bestImg = p.featured_image.replace(/width=\d+/, 'width=400'); } });
        if (bestImg) { m.img.parentNode.style.setProperty('--crbg', 'url("' + bestImg + '")'); m.img.src = bestImg; m.img.alt = maker + ' ' + m.name + ' pattern'; }
      }).catch(function () {}).then(function () { next(i + 1); });
    })(0);
  }

  function whenReady(sel, cb) {
    var el = document.querySelector(sel); if (el) return cb(el);
    var mo = new MutationObserver(function () { var e = document.querySelector(sel); if (e) { mo.disconnect(); cb(e); } });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  loadData().then(function (data) {
    // Safety switch: on the LIVE theme this does nothing until Eli approves (data.live = true).
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    if (role === 'main' && !data.live && !/crbrand=1/.test(location.search)) return;
    return loadPhotos().then(function (photos) { return [data, photos]; });
  }).then(function (res) {
    if (!res) return;
    var mk = res[0].makers || {}, al = res[0].aliases || {}; var info = mk[maker] || mk[al[maker]] || null, photos = res[1];
    whenReady('h1.title', function () { addBlurb(info); });
    // The pattern list is drawn by another script, sometimes in stages: keep checking until this maker's list is there.
    function tryGrid() {
      var uls = [].slice.call(document.querySelectorAll('ul.cr-patterns'));
      if (uls.length > 1) uls = uls.filter(function (ul) { var d = ul.closest('details'); var s = d && d.querySelector('summary'); return s && norm(s.textContent).indexOf(norm(maker)) === 0; });
      if (!uls.length || uls.length > 3) return;
      if (!uls.every(function (ul) { return ul.querySelector(':scope > li > a'); })) return;
      uls.forEach(function (ul) { if (!ul.classList.contains('cr-pgrid')) buildGrid(ul, info, photos); });
    }
    var t = null, mo = new MutationObserver(function () { if (!t) t = setTimeout(function () { t = null; tryGrid(); }, 150); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
    tryGrid();
  });
})();
